var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('surveys-grid',{attrs:{"type":1,"items":_vm.polls,"page-title":_vm.pageTitle,"return-page":"polls","empty-text":"Brak ankiet"},on:{"refresh":_vm.refresh}})}
var staticRenderFns = []

export { render, staticRenderFns }